'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const RevenueChart = dynamic(() => import('@/app/reporting/components/RevenueAreaChart'), { ssr: false });
const CollectionsChart = dynamic(() => import('@/app/reporting/components/CollectionsBarChart'), { ssr: false });

export default function RevenueChartPanel() {
  const [activeTab, setActiveTab] = useState<'revenue' | 'collections'>('revenue');

  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between flex-wrap gap-3">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Revenue & Collections — Last 30 Days</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Daily revenue generated vs collected · June 1 – July 1, 2026</p>
        </div>
        <div className="flex items-center gap-1 bg-muted rounded-md p-1">
          {(['revenue', 'collections'] as const).map(tab => (
            <button
              key={`tab-${tab}`}
              onClick={() => setActiveTab(tab)}
              className={`text-xs px-3 py-1.5 rounded-md font-medium transition-colors capitalize ${activeTab === tab ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
            >
              {tab === 'revenue' ? 'Revenue' : 'Collections'}
            </button>
          ))}
        </div>
      </div>
      <div className="px-5 py-4">
        {activeTab === 'revenue' ? <RevenueChart /> : <CollectionsChart />}
        <div className="mt-4 grid grid-cols-4 gap-4 pt-3 border-t border-border">
          {[
            { id: 'rc-avg', label: 'Daily Avg', value: '$54,200', color: 'text-foreground' },
            { id: 'rc-high', label: 'Best Day', value: '$74,800', color: 'text-success' },
            { id: 'rc-low', label: 'Slowest Day', value: '$31,400', color: 'text-danger' },
            { id: 'rc-month', label: 'Month Total', value: '$1.63M', color: 'text-secondary' },
          ].map((m) => (
            <div key={m.id} className="text-center">
              <div className={`text-base font-bold font-tabular ${m.color}`}>{m.value}</div>
              <div className="text-xs text-muted-foreground">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}